$(function () {
    $("[data-timePicker]").flatpickr({
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        locale: getLang(),
    });
});